import { render, staticRenderFns } from "./ModalCompanyConfig.vue?vue&type=template&id=3f3b45f7"
import script from "./ModalCompanyConfig.vue?vue&type=script&lang=js"
export * from "./ModalCompanyConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports